import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { CodeBlock, BlockType } from '@appblocks/codegeneration/types';

export default class Filenum extends BaseFeature {
    constructor() {
        super();
        this.id = 'filenum';
        this.name = 'Filenum';
        this.fileLinks = [
            // 'filenum\\filenum.tbs',
            // 'filenum\\filenum.tbh',
        ];
        this.files = [
            'filenum.xtxt',
            'libraries/filenum/filenum.tbh',
            'libraries/filenum/filenum.tbs',
        ];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const maxFileNameLen = 32;
        blocks.push({
            location: 'FILENUM_XTXT',
            blockType: BlockType.CODE,
            template: `
#define FILENUM_MAX_FILENAME_LEN ${maxFileNameLen}`,
        });

        return blocks;
    }
}
